import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/authContext';

const API = '/api';

export default function RecuperarObrasPage() {
  const { token, role } = useContext(AuthContext);
  const [obras, setObras] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [restaurandoId, setRestaurandoId] = useState(null);

  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const cargarInactivas = async () => {
    setCargando(true);
    setError('');
    try {
      const res = await fetch(`${API}/obras/inactivas`, { headers });
      if (!res.ok) throw new Error('Error al cargar obras inactivas');
      const data = await res.json();
      setObras(data.data || []);
    } catch (e) {
      setError(e.message);
    }
    setCargando(false);
  };

  useEffect(() => {
    if (role !== 'admin') return;
    cargarInactivas();
  }, [role]);

  if (role !== 'admin') {
    return (
      <div className="p-8 text-center text-gray-500">
        Acceso denegado. Solo administradores.
      </div>
    );
  }

  const handleRestaurar = async (id) => {
    if (!window.confirm(`¿Restaurar la obra ${id}? Se volverá a mostrar en el listado principal.`)) return;
    setRestaurandoId(id);
    setError('');
    setExito('');
    try {
      const res = await fetch(`${API}/obras/${encodeURIComponent(id)}/reactivar`, {
        method: 'POST',
        headers,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Error al reactivar');
      setExito(`Obra ${id} reactivada correctamente`);
      cargarInactivas();
    } catch (e) {
      setError(e.message);
    }
    setRestaurandoId(null);
  };

  return (
    <div className="p-6 w-full max-w-full">
      <h1 className="text-xl font-bold text-gray-800 mb-4">
        Recuperar obras dadas de baja
      </h1>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 mb-4">
          {error}
        </div>
      )}
      {exito && (
        <div className="bg-green-50 border border-green-200 text-green-700 text-sm rounded p-3 mb-4">
          {exito}
        </div>
      )}

      {cargando ? (
        <p className="text-gray-500 text-sm">Cargando...</p>
      ) : obras.length === 0 ? (
        <p className="text-gray-500 text-sm">No hay obras dadas de baja.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Partido</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Versión</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Fecha actualización</th>
                <th className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase">Acción</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {obras.map((o) => (
                <tr key={o.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 font-mono text-xs">{o.cg_01_id_partido_obra}</td>
                  <td className="px-4 py-2">{o.cg_02_nombre_obra || '(sin nombre)'}</td>
                  <td className="px-4 py-2">{o.partido_nombre || '-'}</td>
                  <td className="px-4 py-2">{o.cg_16_estado || '-'}</td>
                  <td className="px-4 py-2 text-center">{o.version}</td>
                  <td className="px-4 py-2 text-xs text-gray-500">
                    {o.cg_05_fecha_actualizacion
                      ? new Date(o.cg_05_fecha_actualizacion).toLocaleDateString('es-AR')
                      : '-'}
                  </td>
                  <td className="px-4 py-2 text-center">
                    {o.baja_por_cambio_partido ? (
                      <button
                        disabled
                        title="No recuperable: dada de baja por cambio de partido (existe el proyecto migrado con los mismos datos)"
                        className="bg-gray-300 text-gray-500 text-xs px-3 py-1.5 rounded font-medium cursor-not-allowed"
                      >
                        No recuperable
                      </button>
                    ) : (
                      <button
                        onClick={() => handleRestaurar(o.cg_01_id_partido_obra)}
                        disabled={restaurandoId === o.cg_01_id_partido_obra}
                        className="bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white text-xs px-3 py-1.5 rounded font-medium"
                      >
                        {restaurandoId === o.cg_01_id_partido_obra ? 'Restaurando...' : 'Restaurar'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
